import GradientAvatar from '@/shared/components/GradientAvatar';
import { getAvatarInitials } from '@/shared/utils/string';
import React from 'react';

interface AccountAvatarProps {
  accountId: string;
  accountName: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * AccountAvatar Component
 *
 * A specialized wrapper around GradientAvatar for account-specific use.
 * Generates a consistent, deterministic avatar gradient based on account ID.
 */
const AccountAvatar: React.FC<AccountAvatarProps> = ({
  accountId,
  accountName,
  size = 'md',
  className,
}) => {
  // Get the initials from the account name for display
  const displayInitials = getAvatarInitials(accountName || '');

  return (
    <GradientAvatar gradientKey={accountId} size={size} className={className}>
      {displayInitials}
    </GradientAvatar>
  );
};

export default AccountAvatar;
